import { CreateUser as ICreateUser, ITableUser, IUser } from '@monorepo/interfaces';
import { FilterState } from '@siemens/component-lib';
import { TableSortState } from '../../shared/interfaces/table-sort-state';

export class LoadUser {
    static readonly type = '[User Management] Load user';
}

export class LoadUsers {
    static readonly type = '[User Management] Load Users';

    constructor(
        public payload: {
            page: number;
            pageSize: number;
            filters?: FilterState<ITableUser>;
            searchTerm?: string;
            sort?: TableSortState;
            roles?: string[];
            accountingUnitIds?: string[];
        }
    ) {}
}

export class LoadSelectedUser {
    static readonly type = '[User Management] Load Selected User';

    constructor(public userId: string) {}
}

export class ExportUsers {
    static readonly type = '[User Management] Export Users';
    constructor(
        public payload: {
            filters?: FilterState<ITableUser>;
            searchTerm?: string;
            sort?: TableSortState;
            roles?: string[];
            accountingUnitIds?: string[];
        }
    ) {}
}

export class ClearDownloadLink {
    static readonly type = '[User Management] Clear Download Link';
}

export class CreateUser {
    static readonly type = '[User Management] Create User';

    constructor(public user: ICreateUser) {}
}

export class UpdateUser {
    static readonly type = '[User Management] Update User';

    constructor(
        public userId: string,
        public user: IUser
    ) {}
}

export class DeleteUser {
    static readonly type = '[User Management] Delete User';

    constructor(public userId: string) {}
}

export class CheckUserExists {
    static readonly type = '[User Management] Check User Exists';

    constructor(public oid: string) {}
}
